import type { UseQueryOptions, UseQueryResult } from 'react-query';
import { useQuery } from 'react-query';

import type { IErrorPayload } from '../../Api';
import type { IColorUser } from '../ColorUser';

export const SESSIONS_ENDPOINT: string = '/api/v1/sessions';

export const ACCOUNTS_ENDPOINT: string = '/api/v1/accounts';

export function useAuthSession(
  queryOptions: UseQueryOptions<undefined, IErrorPayload>,
  baseUrl: string = ''
): UseQueryResult<undefined, IErrorPayload> {
  const endpoint: string = `${baseUrl}${SESSIONS_ENDPOINT}`;
  return useQuery<undefined, IErrorPayload>({
    queryKey: [endpoint],
    ...queryOptions,
  });
}

export function useAuthenticatedUser(
  userIsAuthenticated: boolean,
  queryOptions: UseQueryOptions<IColorUser>,
  baseUrl: string = ''
): UseQueryResult<IColorUser> {
  const endpoint: string = `${baseUrl}${ACCOUNTS_ENDPOINT}`;
  return useQuery<IColorUser>({
    queryKey: [endpoint],
    ...queryOptions,
    enabled: queryOptions.enabled || userIsAuthenticated,
  });
}
